import { createFileRoute } from '@tanstack/react-router';
import { UpdatePhonePage } from '../components/pages/SettingsPage/UpdatePhonePage';

export const Route = createFileRoute('/account/settings_/phone')({
  component: UpdatePhonePage,
});
